const GRID_SELECTOR = '.collection-grid'
const CARD_SELECTOR = '[data-product-card]'
const PROMO_SELECTOR = '.collection-promo-card'

// When the section is configured with a default sort (e.g. the "All" collection
// defaults to Best selling) and the visitor hasn't chosen one, redirect once to
// apply it via the `sort_by` param so the grid and sort dropdown stay in sync.
// Uses `replace` so it doesn't add a history entry; the param's presence on the
// next load prevents a redirect loop.
;(function applyDefaultSort() {
  const gridWrapper = document.querySelector('[data-collection-grid]')
  const defaultSort = gridWrapper?.dataset.defaultSort
  if (!defaultSort) return
  const url = new URL(globalThis.location.href)
  if (url.searchParams.has('sort_by')) return
  url.searchParams.set('sort_by', defaultSort)
  globalThis.location.replace(url.toString())
})()
// The promo card should sit after this many visible products so the flex grid
// packs cleanly (a full first row, then a product + the 2-wide promo) even once
// CA-unavailable products are hidden.
const PROMO_AFTER_VISIBLE = 4

function isCaActive() {
  return document.body.classList.contains('ca-active')
}

// A card is visually hidden only when CA is active and it's CA-unavailable —
// matches the `body.ca-active … [data-ca-available='false']` CSS rule.
function isCardVisible(card, caActive) {
  return !(caActive && card.dataset.caAvailable === 'false')
}

// Keep the promo card directly after the 4th visible product so hidden CA cards
// don't leave an empty slot in the row before it.
function positionPromoCards() {
  const caActive = isCaActive()
  document.querySelectorAll(GRID_SELECTOR).forEach((grid) => {
    const promo = grid.querySelector(PROMO_SELECTOR)
    if (!promo) return

    const visible = [...grid.querySelectorAll(CARD_SELECTOR)].filter((card) =>
      isCardVisible(card, caActive),
    )
    const anchor = visible[PROMO_AFTER_VISIBLE - 1]

    if (anchor) {
      if (anchor.nextElementSibling !== promo) anchor.after(promo)
    } else if (grid.lastElementChild !== promo) {
      grid.appendChild(promo)
    }
  })
}

positionPromoCards()

// `region.js` toggles `body.ca-active` synchronously on this event; defer to the
// next frame so the class is settled before we recompute visible products.
document.addEventListener('theme:region:state-changed', () => {
  requestAnimationFrame(positionPromoCards)
})
document.addEventListener('theme:cards:appended', positionPromoCards)

const loadMoreBtn = document.querySelector('[data-load-more]')
if (loadMoreBtn) {
  const grid = document.querySelector(GRID_SELECTOR)

  loadMoreBtn.addEventListener('click', async () => {
    const nextUrl = loadMoreBtn.dataset.nextUrl
    if (!nextUrl) return

    loadMoreBtn.disabled = true
    loadMoreBtn.textContent = 'Loading…'

    try {
      const res = await fetch(nextUrl)
      const html = await res.text()
      const doc = new DOMParser().parseFromString(html, 'text/html')

      const newCards = doc.querySelectorAll(`${GRID_SELECTOR} ${CARD_SELECTOR}`)
      newCards.forEach((card) => grid.appendChild(document.importNode(card, true)))
      document.dispatchEvent(new CustomEvent('theme:cards:appended'))

      const nextBtn = doc.querySelector('[data-load-more]')
      if (nextBtn?.dataset.nextUrl) {
        loadMoreBtn.dataset.nextUrl = nextBtn.dataset.nextUrl
        loadMoreBtn.disabled = false
        loadMoreBtn.textContent = 'Load more'
      } else {
        loadMoreBtn.remove()
      }
    } catch {
      loadMoreBtn.disabled = false
      loadMoreBtn.textContent = 'Load more'
    }
  })
}
